import { cva } from '@/styled-system/css';

export const verticalNavRootRecipe = cva({
  base: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 'obj.default',
    padding: '{spacing.tightest} {spacing.tighter}',
    minWidth: '5000',
  },
  variants: {
    background: {
      true: {
        backgroundColor: 'bg.neutral',
      },
      false: {
        backgroundColor: 'transparent.invisible',
      },
    },
    elevated: {
      true: {},
      false: {},
    },
    outlined: {
      true: {
        borderStyle: 'solid',
        borderWidth: 'default',
        borderColor: 'border.muted',
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      elevated: false,
      background: true,
      css: {
        backgroundColor: 'bg.neutral',
      },
    },
    {
      elevated: true,
      background: true,
      css: {
        boxShadow: 'md',
        backgroundColor: 'bg.elevated.mediumShadow',
      },
    },
  ],
});
